import type { BaseButtonRootProps } from '#src/base/button/base_button.tsx';
import { BaseButton } from '#src/base/button/base_button.tsx';

export type ButtonProps = Omit<BaseButtonRootProps, 'asChild'>;

export const Button = ({ children, ...props }: ButtonProps) => (
  <BaseButton.Root {...props}>
    <BaseButton.Content
      variant={props.variant}
      size={props.size}
      tone={props.tone}
      loading={props.loading}
    >
      {children}
    </BaseButton.Content>
  </BaseButton.Root>
);
